var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottomSetting shopping",on:{"click":function($event){$event.preventDefault();return _vm.goHomeShopping($event)}}},[_vm._v("모바일 주문")])}
var staticRenderFns = []

export { render, staticRenderFns }